import { Injectable, inject, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { AUTH_CONFIGURED } from './auth-config';

/**
 * Thin wrapper over MsalService exposing the signed-in account as a signal, so
 * templates can react to sign-in/out without touching MSAL internals.
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly msal = inject(MsalService);

  readonly account = signal<AccountInfo | null>(null);
  readonly configured = AUTH_CONFIGURED;

  /** Re-read the active account from MSAL (call after any interaction settles). */
  syncActiveAccount(): void {
    const active =
      this.msal.instance.getActiveAccount() ??
      this.msal.instance.getAllAccounts()[0] ??
      null;
    if (active && !this.msal.instance.getActiveAccount()) {
      this.msal.instance.setActiveAccount(active);
    }
    this.account.set(active);
  }

  logout(): void {
    this.msal.instance.logoutRedirect();
  }
}
